import Http from './http';
import constant from 'lodash/constant';

const empty = constant({});

class AuthAPI {
   state() {
      return Http.get('auth').catch(empty);
   }
   logout() {
      return Http.delete('auth').catch(() => true);
   }
   auth(username, password) {
      return Http.post('auth', { username, password }).catch(empty);
   }
}

export default new AuthAPI();
